import { __rest } from "tslib";
import React from 'react';
import { TextInput } from '@gravity-ui/uikit';
import isNumber from 'is-number';
export const NumberInput = (props) => {
    const { value, onUpdate, min, max } = props, textInputProps = __rest(props, ["value", "onUpdate", "min", "max"]);
    return (React.createElement(TextInput, Object.assign({ value: isNumber(value) ? String(value) : '', onUpdate: (v) => {
            if (isNumber(v)) {
                onUpdate(parseInt(v, 10));
            }
            else {
                onUpdate();
            }
        }, controlProps: { min, max }, type: "number" }, textInputProps)));
};
